// CombinedComponent.js  
import React, { useState, useEffect } from 'react';  
import { useParams } from 'react-router-dom';  
import { fetchNewtelemetry, fetchOneHourTotalTelemetry, fetchNewHarvestImage, fetchDailyTotalTelemetry, API_URL } from './api'; // api.js からインポート  
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, BarElement } from 'chart.js';  
import styled, { keyframes } from 'styled-components';  
import Loading from '../components/Loading_robo';  
import roboOnImage from './images/robot-img-02.jpg';  
import roboOffImage from './images/robot-img-03.jpg';  
import ChartComponent from '../components/Chart_RoboHarvest';  
import LatestHarvestImages from '../components/Image_RoboLatestImages';  
import ChartDailyHarvest from '../components/Chart_DailyHarvest';  
import CountUp from 'react-countup';  
  
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title, Tooltip, Legend);  

// 環境変数からデモモードを判断    
const isDemoMode = (process.env.REACT_APP_DEMO_MODE || 'false') === 'true';   
  
const fontFamily = `  
  YakuHanJP_Narrow,  
  'TTNorms-Medium',  
  'RodinPro-DB',  
  'YuGothic',  
  '游ゴシック',  
  'Yu Gothic',  
  'ヒラギノ角ゴ ProN W3',  
  'Hiragino Kaku Gothic ProN',  
  sans-serif  
`;  

// コンテナのスタイルを調整  
const Container = styled.div`  
  padding: 20px;  
  background: #fafafa;  
  min-height: 100vh;  
  font-family: ${fontFamily};  
`;  
  
// アニメーションを設定  
const zoomInOut = keyframes`  
  0% { transform: scale(1); }  
  50% { transform: scale(0.9); }  
  100% { transform: scale(1); }  
`;  
  
// 画像コンテナのスタイルを調整  
const ImageContainer = styled.div`  
  display: flex;  
  justify-content: center;  
  width: 100%;  
  margin: 20px 0;  
`;  
  
// アニメーション付き画像のスタイルを調整  
const AnimatedImageOn = styled.img`  
  border-radius: 15px;  
  width: 100%;  
  max-width: 400px; /* 画像の最大幅を設定 */  
  height: auto;  
  object-fit: cover;  
  animation: ${zoomInOut} 2s infinite;  
`;  
  
// アニメーション付き画像のスタイルを調整  
const AnimatedImageOff = styled.img`  
  border-radius: 15px;  
  width: 100%;  
  max-width: 400px; /* 画像の最大幅を設定 */  
  height: auto;  
  object-fit: cover;  
`;  
  
// タイトルテキストのスタイル  
const TitleText = styled.h2`  
  color: #007c3e;  
  font-size: 24px;  
  margin-bottom: 10px;  
`;  
  
// ステータス表示用のテキストスタイル  
const StatusText = styled.p`  
  font-size: 1.2rem; /* フォントサイズを少し小さく */  
  color: #666666; /* ラベルの色を少し落ち着いた色に変更 */  
  margin-top: 5px;  
  @media (max-width: 768px) {  
    font-size: 4vw;  
  }  
`;  
  
// ステータスの値表示用のスタイル  
const StatusValue = styled.p`  
  font-size: 2.5vw;  
  color: ${({ color }) => color || 'black'};  
  font-weight: bold;  
  margin-bottom: 5px; /* 数値の下に余白を追加 */  
  @media (max-width: 768px) {  
    font-size: 8vw;  
  }  
`;  
  
// ステータスコンテナのスタイルを調整  
const StatusContainer = styled.div`  
  display: flex;  
  justify-content: space-around;  
`;  
  
// ステータス項目のスタイルを調整  
const StatusItem = styled.div`  
  width: 48%;  
  background-color: #ffffff;  
  border-radius: 15px;  
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);  
  display: flex;  
  flex-direction: column;  
  justify-content: center;  
  align-items: center;  
  min-height: 100px;  
  height: auto;  
  text-align: center;  
`;  
  
// ボタンのスタイルを調整  
const StyledButton = styled.a`  
  // display: flex;  
  align-items: center;  
  justify-content: center;  
  border: none;  
  border-radius: 8px;  
  color: white;  
  font-size: 20px;  
  height: 50px;  
  text-decoration: none; /* ここを追加 */  
`;  
  
// ヒストリーボタンのコンテナスタイルを調整  
const HistoryButtonContainer = styled.div`  
  display: flex;  
  justify-content: space-around;  
  margin-bottom: 20px;  
`;  
  
// ヒストリーボタンのスタイル  
const HistoryButton = styled(StyledButton)`  
  background-color: #006331;  
  width: 48%;  
  border-radius: 15px;  
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);  
  flex-direction: column;  
  display: flex;  
`;  
  
// ステータスチェック用のカスタムフック  
const useCheckStatus = (id) => {  
  const [status, setStatus] = useState(null);  
  useEffect(() => {  
    if (!id) {  
      setStatus('IDが無効です');  
      return;  
    }  
    let isMounted = true;  
    const fetchStatus = async () => {  
      try {  
        const response = await fetch(`${API_URL}/status?hubName=command_hub_${id}`, { method: 'GET' });  
        if (isMounted) {  
          if (response.status === 404) {  
            setStatus('電源オフ');  
          } else {  
            setStatus('稼働中');  
          }  
        }  
      } catch (error) {  
        if (isMounted) {  
          console.error('Error fetching status:', error);  
          setStatus('オフライン');  
        }  
      }  
    };  
    fetchStatus();  
    const timer = setInterval(() => fetchStatus(), 60000);  
    return () => {  
      isMounted = false;  
      clearInterval(timer);  
    };  
  }, [id]);  
  return status || '読み込み中...';  
};  
  
// データ取得用のカスタムフック  
const useFetchAPI = (apiFunc, id, params = 1) => {  
  const [data, setData] = useState(null);  
  const [loading, setLoading] = useState(true);  
  const [error, setError] = useState(null);  
  
  useEffect(() => {  
    let isMounted = true;  
    const fetchData = async () => {  
      const startTime = performance.now();  
      console.log(`[useFetchAPI] Fetch starting for ${apiFunc.name} with id ${id}`);  
  
      apiFunc(id, params)  
        .then((data) => {  
          const endTime = performance.now();  
          console.log(`[useFetchAPI] Fetch completed for ${apiFunc.name} in ${endTime - startTime} ms`);  
          console.log(`[useFetchAPI] Number of records fetched for ${apiFunc.name}: ${Array.isArray(data) ? data.length : 'N/A'}`);  
          if (isMounted) {  
            setData(data);  
            setLoading(false);  
          }  
        })  
        .catch((e) => {  
          const endTime = performance.now();  
          console.log(`[useFetchAPI] Fetch failed for ${apiFunc.name} in ${endTime - startTime} ms`);  
          if (isMounted) {  
            setError(e.message);  
            setLoading(false);  
          }  
        });  
    };  
  
    fetchData();  
    const timer = setInterval(fetchData, 60000);  
  
    return () => {  
      isMounted = false;  
      clearInterval(timer);  
    };  
  }, [apiFunc, id, params]);  
  
  return { data, loading, error };  
};  
  
function CombinedComponent() {    
  const { id } = useParams();    
  const { data: newData, loading: newLoading, error: newError } = useFetchAPI(fetchNewtelemetry, id);    
  const { data: images, loading: imagesLoading, error: imagesError } = useFetchAPI(fetchNewHarvestImage, id);    
  const { data: totalData, loading: totalLoading, error: totalError } = useFetchAPI(fetchOneHourTotalTelemetry, id);    
  const { data: dailyCounts, loading: dailyLoading, error: dailyError } = useFetchAPI(fetchDailyTotalTelemetry, id, 7);    
  const status = useCheckStatus(id);    
  
  const chartData = totalData && totalData.map((item) => {    
    const dateObj = new Date(item.hour);    
    const day = dateObj.getDate();    
    const hour = dateObj.getHours();    
    return { ...item, hour: `${day}日 ${hour}時` };    
  });    
  
  const latestData = newData && newData[0];    
  const batteryLevel = latestData ? latestData.battery : 'N/A';    
  const totalSuccess = chartData ? chartData.reduce((sum, item) => sum + (item.eventCounts.ok || 0), 0) : 'N/A';    
  
  return (    
    <Container>    
      <TitleText>    
        {id} - {status || '読み込み中...'}    
      </TitleText>    
  
      <ImageContainer>    
        {status === '稼働中' ? (    
          <AnimatedImageOn src={roboOnImage} />    
        ) : (    
          <AnimatedImageOff src={roboOffImage} />    
        )}    
      </ImageContainer>    
  
      {!isDemoMode && (  
        <StatusContainer>    
          <StatusItem>    
            {totalLoading ? (    
              <StatusValue>読み込み中...</StatusValue>    
            ) : totalError ? (    
              <StatusValue>エラー</StatusValue>    
            ) : (    
              <StatusValue color="Green">    
                <CountUp    
                  end={totalSuccess}    
                  decimals={0}    
                  suffix="個"    
                  duration={2}    
                />    
              </StatusValue>    
            )}    
            <StatusText>収穫量</StatusText>    
          </StatusItem>    
    
          <StatusItem>    
            {newLoading ? (    
              <StatusValue>読み込み中...</StatusValue>    
            ) : newError ? (    
              <StatusValue>エラー</StatusValue>    
            ) : (    
              <StatusValue color="Green">    
                <CountUp    
                  end={batteryLevel}    
                  decimals={0}    
                  suffix="％"    
                  duration={2}    
                />    
              </StatusValue>    
            )}    
            <StatusText>バッテリー</StatusText>    
          </StatusItem>    
        </StatusContainer>    
      )}
  
      {totalLoading ? (    
        <Loading />    
      ) : totalError ? (    
        <div>Error: {totalError}</div>    
      ) : (    
        <ChartComponent data={chartData} />    
      )}    
  
      {dailyLoading ? (    
        <Loading />    
      ) : dailyError ? (    
        <div>Error: {dailyError}</div>    
      ) : (    
        <ChartDailyHarvest data={dailyCounts} />    
      )}    
  
      {!isDemoMode && (  
      imagesLoading ? (      
        <Loading />      
      ) : imagesError ? (      
        <div>Error: {imagesError}</div>      
      ) : (      
        <LatestHarvestImages images={images} />      
      )  
    )}     
  
      <HistoryButtonContainer>    
        {!isDemoMode && (    
          <HistoryButton href={`/${id}/video-feed`} disabled={status !== '稼働中'}>映像確認</HistoryButton>    
        )}    
        {!isDemoMode && ( 
        <HistoryButton href={`/${id}/latest-images`}>画像履歴</HistoryButton>  
        )}  
        {!isDemoMode && (    
          <HistoryButton href={`/${id}/new-data`}>動作履歴</HistoryButton>    
        )}    
      </HistoryButtonContainer>    
  
      <p style={{ textAlign: 'center' }}>    
        <a href="/robots">ロボット一覧に戻る</a>    
      </p>    
    </Container>    
  );    
}    
  
export default CombinedComponent;  
